import { connectTelemetryLifecycle } from "@/app/telemetry/connect-telemetry-lifecycle";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "@/app/App";
import { connectSessionLifecycle } from "@/app/session/connect-session-lifecycle";
import { createQueryClient } from "@/services/query/create-query-client";
import "@/app/styles/globals.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("The application root element was not found.");
}

// Bind cleanup before mounting any route/query, including in React StrictMode.
const queryClient = createQueryClient();
const disconnectSession = connectSessionLifecycle(queryClient);
const disconnectTelemetry = connectTelemetryLifecycle();
import.meta.hot?.dispose(() => {
  disconnectTelemetry();
  disconnectSession();
  queryClient.clear();
});

createRoot(rootElement).render(
  <StrictMode>
    <App queryClient={queryClient} />
  </StrictMode>,
);
